import React from 'react';


import {BulkActionTool} from 'src/components/bulk-tool';
import {
    bulkDischargeAccountEntitlements,
    getDischargeAccountEntitlementsProgress,
} from 'src/openapi/admin/apis/BulkDischargeAccountEntitlementsApi';
import {useAppDispatch} from 'src/store/hooks';

import {FlatButton} from '@pb/kit-component-button';
import {useShown} from '@pb/kit-hooks-use-shown';

import {
    TOOL_PROGRESS_LABEL,
    TOOL_STACK_OVERFLOW_MESSAGE,
    TOOL_TASK,
    TOOL_TITLE,
} from './constants';
import {UnassignAccountEntitlementsModal} from './unassign-account-entitlements.modal';
import {
    selectUnassignAccountEntitlementsBulkUuid,
    selectUnassignAccountEntitlementsTask,
    setBackgroundTask,
    setShown,
    setUuid,
} from './unassign-account-entitlements.slice';

import type {UpdateEntitlementsRelation} from 'src/openapi/admin/models/UpdateEntitlementsRelation';

type Props = {
    accountId: number,
    selectionKey: string,
    onDone: () => void,
};

export const UnassignAccountEntitlementsTool = ({selectionKey, onDone, accountId}: Props) => {
    const apiDispatch = useAppDispatch();
    const {shown, onClick, onClose} = useShown();

    return (
        <>
            <FlatButton onClick={onClick}>
                <b>{TOOL_TITLE}</b>
            </FlatButton>
            <BulkActionTool<UpdateEntitlementsRelation>
                shown={shown}
                onClose={onClose}

                toolTask={TOOL_TASK}
                toolName={TOOL_TITLE}
                progressLabel={TOOL_PROGRESS_LABEL}

                taskSelector={selectUnassignAccountEntitlementsTask}
                uuidSelector={selectUnassignAccountEntitlementsBulkUuid}

                setUuid={setUuid}
                setTask={setBackgroundTask}
                setResultShown={setShown}
                saveActionRequest={(updateEntitlementsRelation, options) => (
                    apiDispatch(bulkDischargeAccountEntitlements({...options, updateEntitlementsRelation}))
                )}
                getProgress={id => apiDispatch(getDischargeAccountEntitlementsProgress({id}))}

                stackOverflowMessage={TOOL_STACK_OVERFLOW_MESSAGE}
                onDone={onDone}>
                {({processAction, onCloseModal}) => (
                    <UnassignAccountEntitlementsModal
                        accountId={accountId}
                        selectionKey={selectionKey}
                        onCloseModal={onCloseModal}
                        processAction={processAction}
                    />
                )}
            </BulkActionTool>
        </>
    );
};
